import React, { useMemo } from 'react';

import { DisablePrefetchLink } from '@orgnc/core/components/atoms';
import {
  FeaturedImage,
  FeaturedImageButton,
} from '@orgnc/core/components/themes/Elements/components';
import { Box, Link, useTheme } from '@mui/material';
import { IArticleGridProps } from '@orgnc/core/components/blocks/AcfArticleListBlock/Layouts';

const AchArticleGridLayout3colExcerpt: React.FC<IArticleGridProps> = ({
  hasImageLazyLoad = true,
  posts,
}) => {
  const theme = useTheme();

  const primaryPosts = useMemo(() => {
    if (Array.isArray(posts)) {
      if (posts.length > 0) {
        return (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(3, 1fr)',
              },
              gap: 6,
              padding: 0,
              mb: '4rem',
            }}
          >
            {posts.map((post) => (
              <DisablePrefetchLink
                key={post.databaseId}
                href={post.uri || ''}
                passHref
              >
                <Box
                  component="article"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    position: 'relative',
                    boxSizing: 'border-box',
                  }}
                >
                  {post.featuredImage?.node?.sourceUrl && (
                    <FeaturedImageButton>
                      <FeaturedImage
                        ratio="1:1"
                        loading={hasImageLazyLoad ? 'lazy' : 'eager'}
                        src={post.featuredImage.node.sourceUrl}
                        style={{ objectFit: 'cover' }}
                      />
                    </FeaturedImageButton>
                  )}
                  <Box
                    sx={{
                      py: 0,
                      color: 'text.primary',
                      mt: 2,
                      textAlign: 'center',
                    }}
                  >
                    {post?.title && (
                      <Box sx={{ lineHeight: 1.05 }}>
                        <DisablePrefetchLink href={post?.uri || '#'} passHref>
                          <Link
                            dangerouslySetInnerHTML={{ __html: post.title }}
                            sx={{
                              textDecoration: 'none',
                              color: 'inherit',
                              fontFamily:
                                theme.typography?.fonts?.sans?.primary,
                              fontSize: {
                                md: '24px',
                                sm: '16px',
                              },
                              opacity: 0.8,
                              lineHeight: 1,
                              transition: 'color 0.3s ease-in-out',
                              '&:hover': {
                                color: 'secondary.main',
                              },
                            }}
                          />
                        </DisablePrefetchLink>
                      </Box>
                    )}
                  </Box>
                  {post?.excerpt && (
                    <Box
                      sx={{
                        mt: 1,
                        textAlign: 'center',
                        color: 'text.secondary',
                        fontSize: {
                          md: '15px',
                          sm: '14px',
                        },
                        fontWeight: 600,
                        opacity: 0.85,
                        cursor: 'pointer',
                        display: { xs: 'none', sm: 'block' },
                      }}
                      dangerouslySetInnerHTML={{ __html: post.excerpt }}
                    />
                  )}
                </Box>
              </DisablePrefetchLink>
            ))}
          </Box>
        );
      }
    }

    return null;
  }, [hasImageLazyLoad, posts, theme.typography?.fonts?.sans?.primary]);

  if (!primaryPosts) return null;

  return primaryPosts;
};

export default AchArticleGridLayout3colExcerpt;
